export default "__VITE_ASSET__B7r_UIyI__"